import React from "react";
import moment from "moment-timezone";

import i18n from "../../../../../../i18n";

const COLOR = {
  sent: "#ffaa55",
  rejected: "#ff4d4e",
  accepted: "#3D64FF"
};

const TITLE = {
  sent: i18n.t("opportunity:process.candidateDetails.offer.status.sent"),
  rejected: i18n.t(
    "opportunity:process.candidateDetails.offer.status.rejected"
  ),
  accepted: i18n.t("opportunity:process.candidateDetails.offer.status.accepted")
};

export const OfferDescription = ({ lastOffer }) => {
  const {
    salaryCurrency,
    salaryType,
    salaryValue,
    startDate,
    status,
    reason
  } = lastOffer;

  const formattedDate = moment(startDate).format("L");

  const hasSalaryInfo =
    salaryCurrency &&
    salaryValue !== undefined &&
    salaryValue !== null &&
    salaryType;

  const dateText = `A partir del ${formattedDate}`;
  return (
    <>
      <p>
        {hasSalaryInfo
          ? `Oferta: ${salaryCurrency} ${salaryValue} (${salaryType}) a partir del ${formattedDate}`
          : dateText}
      </p>
      {status === "rejected" && reason && <p>{`Motivo: ${reason}`}</p>}
    </>
  );
};

export const getOfferStatus = lastOffer => {
  return { color: COLOR[lastOffer.status], status: TITLE[lastOffer.status] };
};

export default OfferDescription;
